import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {

  selectClear(e){
    e.preventDefault();
    // このコントローラが付与された label 要素直下の入力群のみクリア
    const container = this.element.nextElementSibling; // 通常は <div class="is-flex"> が続く
    if (!container) return;
    const inputs = container.querySelectorAll('input, select, textarea');
    inputs.forEach((el) => {
      if (el.type === 'checkbox' || el.type === 'radio') {
        el.checked = false;
      } else {
        el.value = '';
      }
      el.dispatchEvent(new Event('change', { bubbles: true }));
      el.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

}
